<script lang="ts">
  import Border from "../steps/Border.svelte";
  import Colour from "../steps/Colour.svelte";
  import StampType from "../steps/StampType.svelte";
  import TextLines from "../steps/TextLines.svelte";
  import Spacing from "../steps/Spacing.svelte";
  import type { ICanvas } from "src/ts/Interfaces";

  export let canvas: ICanvas;
</script>

<StampType hidden={canvas.hideStampType} bind:selected={canvas.stampType} />

<TextLines
  hidden={false}
  bind:lines={canvas.lines}
  bind:sections={canvas.sections}
/>

<Colour
  hidden={canvas.hideColors || canvas.stampType === "Traditional"}
  bind:selected={canvas.colors[0]}
/>

<Border hidden={canvas.hideBorder} bind:border={canvas.border} />

<Spacing hidden={canvas.hideSpacing} bind:spacing={canvas.spacing} />
